export { default as typedArrayLength } from "typed-array-length";
